import { useContext } from "react";
import { DatatableSearchContext } from "../../Providers";

export const useDatatableSearch = () => {
  const {search, clearSearch, updateSearch} = useContext(DatatableSearchContext);
  return { search, clearSearch, updateSearch };
}
